module.exports = __webpack_public_path__ + "static/img/11j.8749262.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11j.jpg
// module id = BuJ/
// module chunks = 1